import { StyleSheet, ViewStyle } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { OFFERING_CONTENT_STICKY_TOP } from "../offeringLayout/OfferingLayout.style";

const MAIN_CONTAINER_WIDTH = 2560;

const style = () => {
  const { space2, space6, space8, colorTextMedium, colorBgBase, space1, space4, space10, space12, space5 } = theme();

  return StyleSheet.create({
    bottomMessage: {
      marginTop: space8,
    },
    container: {
      backgroundColor: colorBgBase,
      flexDirection: "column",
      flexGrow: 1,
      width: "100%",
    },
    crossSellingBanner: {
      flex: 1,
    },
    desktopProductWrapper: {
      flex: 1,
      marginRight: space6,
    },
    footer: {
      bottom: space4,
      right: space4,
    },
    subtitle: {
      color: colorTextMedium,
    },
    subtitleLarge: {
      textAlign: "center",
    },
    tabsAndProducts: {
      display: "flex",
      justifyContent: "center",
      marginHorizontal: "auto",
      maxWidth: MAIN_CONTAINER_WIDTH,
      width: "100%",
    },
    tabsAndProductsHorizontally: {
      flexDirection: "row",
    },
    tabsAndProductsVertically: {
      flexDirection: "column",
    },
    tabsAndProductsWeb: {
      flexFlow: "row wrap",
      alignItems: "flex-start",
    } as ViewStyle,
    tabsColumn: {
      marginLeft: space10,
      marginRight: space12,
      maxWidth: 233,
    },
    tabsColumnWeb: {
      top: OFFERING_CONTENT_STICKY_TOP,
      position: "sticky",
    } as unknown as ViewStyle,
    tabsRow: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
    title: {
      marginBottom: space1,
    },
    titleArea: {
      paddingHorizontal: space6,
      paddingVertical: space12,
    },
    titleAreaSmall: {
      paddingBottom: 0,
      paddingTop: space5,
    },
    titleLarge: {
      marginBottom: space2,
      textAlign: "center",
    },
  });
};

export { style };
